import { Link } from "wouter";
import { useAuth } from "@/hooks/useAuth";
import TruckAnimation from "@/components/TruckAnimation";

export default function NotFound() {
  const { isAuthenticated, isLoading } = useAuth();

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
      }}
    >
      <p style={{
        fontFamily: "monospace",
        fontSize: 13,
        color: "#C55A11",
        letterSpacing: 4,
        marginBottom: 12,
        margin: "0 0 12px",
      }}>
        ERROR 404
      </p>

      <h1 style={{
        fontFamily: "monospace",
        fontSize: 28,
        color: "#1a1a1a",
        margin: "0 0 8px",
        textAlign: "center",
      }}>
        WRONG TURN
      </h1>

      <p style={{
        fontFamily: "monospace",
        fontSize: 13,
        color: "#666666",
        lineHeight: 1.8,
        margin: "0 0 40px",
        textAlign: "center",
        maxWidth: 360,
        padding: "0 24px",
      }}>
        THE PAGE YOU'RE LOOKING FOR DOESN'T EXIST
      </p>

      <TruckAnimation />

      {!isLoading && (
        isAuthenticated ? (
          <Link href="/dashboard">
            <button
              data-testid="button-go-to-dashboard"
              style={{
                fontFamily: "monospace",
                fontSize: 13,
                backgroundColor: "#C55A11",
                color: "#ffffff",
                padding: "14px 24px",
                borderRadius: 2,
                border: "none",
                cursor: "pointer",
              }}
            >
              GO TO DASHBOARD
            </button>
          </Link>
        ) : (
          <Link href="/">
            <button
              data-testid="button-go-home"
              style={{
                fontFamily: "monospace",
                fontSize: 13,
                backgroundColor: "#C55A11",
                color: "#ffffff",
                padding: "14px 24px",
                borderRadius: 2,
                border: "none",
                cursor: "pointer",
              }}
            >
              GO HOME
            </button>
          </Link>
        )
      )}
    </div>
  );
}
